import styled from 'styled-components';

export const Uploadcontainer = styled.div<any>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border: 2px dashed #eee;
  border-radius: 5px;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  width: 100%;
  cursor: pointer;
  margin-bottom: 20px;
  ${({ isDisabled }) => isDisabled && 'pointer-events: none;'}
  ${({ isFocused }) => isFocused && 'borderColor: #2196f3;'}
  ${({ isDragAccept }) => isDragAccept && 'borderColor: #00e676;'}
  ${({ isDragReject }) => isDragReject && 'borderColor: #ff1744;'}
  .link {
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    color: #2c5cc5;
  }
  p {
    margin: 0 !important;
    font-size: 13px;
  }
`;
export const Wrapper = styled.div`
  width: 100%;
  .title-cont {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .label {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #475867;
    display: flex;
    margin-bottom: 5px;
    align-items: center;
    .icon {
      padding-top: 2px;
    }
  }
  .link {
    color: var(--text-link);
    display: block;
    margin: 0;
    padding: 4px 15px 5px;
    cursor: pointer;
    line-height: 1.5;
    text-align: center;
    font-weight: 500;
    user-select: none;
    font-size: 14px;
    height: auto;
    background-color: #fbfbfb;
  }
  .toggle-btn {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    text-decoration-line: underline;
    color: #475867;
    cursor: pointer;
  }

  .end-adornment {
    padding: 0 !important;
  }
`;
